import splash_background from "../assets/splash_background.png";

export const backgroundStyles: React.CSSProperties = {
    backgroundImage: `url(${splash_background})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  };
